import axiosIns from '@/libs/axios'

const ROOT_URL = '/Clients/data/services'
export default {
  namespaced: true,
  state: {
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      complaints: null,
      transactions: null,
      notes: null,
      sdate: null,
      edate: null,
      customer_person: null,
      customer_technician: null,
      id_service_types: null,
      id_service_statuses: null,
      id_customer_machines: null,
      id_customers: null,
      service_lines: [],
      service_crew: [],
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    search: {
      id_brands: null,
      keyword: null,
    },
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    search(state) {
      return state.search
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        complaints: null,
        transactions: null,
        notes: null,
        sdate: null,
        edate: null,
        customer_person: null,
        customer_technician: null,
        id_service_types: null,
        id_service_statuses: null,
        id_customer_machines: null,
        id_customers: null,
        service_lines: [],
        service_crew: [],
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, params) {
      const data = JSON.stringify({
        where: {
          'services.id': params.id,
        },
        array: false,
        isUpdate: params.isUpdate,
      })
      return axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
  },
}
